export const ALERT_COLORS = [
  'info',
  'success',
  'danger',
  'warning',
  'yellow',
  'light',
  'dark',
]

export const ALERT_COLORS_INFO_1 = ['info', 'success', 'danger']

export const ALERT_COLORS_INFO_2 = ['warning', 'yellow', 'light']

export const ALERT_COLORS_INFO_3 = ['dark']
